import React from "react";

import { HeaderBreadcrumb } from "../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../AdminRoutes";
import { FramerateProfilesListingProvider } from "./context/FramerateProfilesListingProvider";
import { FramerateProfilesListing } from "./listing/FramerateProfilesListing";

export const FramerateProfilesDashboard: React.VFC = () => {
    return (
        <FramerateProfilesListingProvider>
            <PageHeader>
                <HeaderBreadcrumb routes={adminRoutes} />
            </PageHeader>
            <FramerateProfilesListing />
        </FramerateProfilesListingProvider>
    );
};
